import { HttpHandler } from 'msw'

import { getTheme } from './getTheme'

export const theme: HttpHandler[] = [getTheme]
